import script from "./TrendingPairs.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrendingPairs.vue?vue&type=script&setup=true&lang=ts"

import "./TrendingPairs.vue?vue&type=style&index=0&id=f9617fea&scoped=true&lang=css"

import exportComponent from "/Users/jason/u/acsi-ui-balancer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9617fea"]])

export default __exports__